import { FC } from 'react';
import styled from 'styled-components';
import { InternalLinkHighlight } from '../atoms/link-highlight';

const TagList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  list-style: none;
  padding: 0;
  ${({ theme }): string => theme.mixins.margin({ hor: 0, ver: 1 })};
`;

const Tag = styled.li`
  ${({ theme }): string => theme.mixins.margin({ top: 0, left: 0, bottom: 0, right: 1 })};
`;

interface TagsProps {
  tags: ReadonlyArray<string>;
}

const Tags: FC<TagsProps> = ({ tags }) => (
  <TagList>
    {tags.map((tag) => (
      <Tag key={tag}>
        <InternalLinkHighlight to={`/tags/${tag}/`}>#{tag}</InternalLinkHighlight>
      </Tag>
    ))}
  </TagList>
);

export default Tags;
